import styled from 'styled-components'
import { spacing } from '~theme'
import { MediumBody, BodyProps } from './Modal.styles'

// eslint-disable-next-line import/prefer-default-export
export const Content = styled(MediumBody)<BodyProps>`
  display: flex;
  align-items: center;
  gap: ${spacing(0.5)};
`
